module.exports = __webpack_public_path__ + "static/media/laptop.1f665d73.png";